export default "__VITE_ASSET__DG7cEnK7__"